import * as React from 'react';
import {useDispatch} from 'react-redux';

import {Link} from 'shells/link/link';

import {openComposerWithId} from '../../../email/email-composer-actions';

import styles from './cell.module.css';

type RelatedEmailAddress = {
    entityId: string;
    value: {
        value: string;
    };
};

type Props = {
    value: RelatedEmailAddress[] | null | undefined;
};

export function CellEmails(props: Props) {
    const dispatch = useDispatch();

    const handleClick = (entityId: string, value: string) => {
        if (NutClientConfig.sendFromNutshellEnabled) {
            dispatch(openComposerWithId(entityId));
        } else {
            window.open(`mailto:${value}?bcc=bcc@nutshell.com`);
        }
    };

    return props.value
        ? props.value.map<React.ReactNode>((emailAddress: RelatedEmailAddress) => {
              return (
                  <div
                      key={emailAddress.value.value}
                      title={emailAddress.value.value}
                      className={styles['cell-content']}
                  >
                      <Link
                          variant='primary'
                          size='small'
                          onClick={(e) => {
                              e.stopPropagation();
                              handleClick(emailAddress.entityId, emailAddress.value.value);
                          }}
                      >
                          {emailAddress.value.value}
                      </Link>
                  </div>
              );
          })
        : null;
}
